import {useEffect, useState} from 'preact/hooks';

type SVG = typeof import('*.svg');

export function useLazyImage(path: 'shop-promise-logo') {
  const [shopPromiseLogo, setShopPromiseLogo] = useState<string | null>(null);

  useEffect(() => {
    const loadSvg = async () => {
      let image: SVG | null = null;
      switch (path) {
        case 'shop-promise-logo':
          image = await import('./media/shop-promise-logo-purple.svg');
          break;
      }

      setShopPromiseLogo(image?.default);
    };

    loadSvg().catch((error) =>
      // todo: implement error reporting
      // eslint-disable-next-line no-console
      console.warn(`loading image ${path} failed`, error),
    );
  }, [path]);

  return shopPromiseLogo;
}
